import { createRouter, createWebHistory } from 'vue-router';
import i18n from '@/lang/index.js'
import Layout from '@/layout'

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'Home',
    },
  },
  {
    path: '',
    component: Layout,
    redirect: '/home/index',
    children: [
		{
		  path: '/home',
		  component: () => import('@/view/home/index.vue'),
		  name: 'Home',
		  meta: { title: 'menu.home', activeMenu: '/home', noCache: true },
		},
		{
		  path: '/contact',
		  component: () => import('@/view/contact/index.vue'),
		  name: 'Contact',
		  meta: { title: 'menu.contact', activeMenu: '/contact', noCache: true },
		},
		{
		  path: '/about',
		  component: () => import('@/view/about/index.vue'),
		  name: 'About',
		  meta: { title: 'menu.about', activeMenu: '/about', noCache: true },
		}
    ]
  },
  {
  	  path: '/clauseService',
  	  component: () => import('@/view/clause/service.vue'),
  	  name: 'ClauseService',
  	  meta: { title: 'menu.clauseService' },
  },
  {
  	  path: '/clauseUser',
  	  component: () => import('@/view/clause/user.vue'),
  	  name: 'ClauseUser',
  	  meta: { title: 'menu.clauseUser' },
  }
];

const router = createRouter({
  mode:'history',
  routes,
  history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = i18n.global.t(title);
  }
  next();
});

export { router };